// skipcq: JS-W1028
import { useCallback, useEffect, useState } from 'react';
import { listIngestionReviews } from '../services/beerIngestionService';
import { captureBeerIngestionReviewEmpty, captureBeerIngestionReviewError } from '../utils/beerIngestionAnalytics';

const EMPTY_SUMMARY = {
  pendingRuns: 0,
  inProgressRuns: 0,
  pendingCandidates: 0,
  unappliedRuns: 0,
};

export default function useBeerIngestionReviews(stateCode) {
  const [rows, setRows] = useState([]);
  const [summary, setSummary] = useState(EMPTY_SUMMARY);
  const [loading, setLoading] = useState(Boolean(stateCode));
  const [error, setError] = useState(null);
  const [reloadToken, setReloadToken] = useState(0);

  const refresh = useCallback(() => {
    setReloadToken((token) => token + 1);
  }, []);

  useEffect(() => {
    if (!stateCode) {
      return undefined;
    }
    let cancelled = false;
    const loadRows = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await listIngestionReviews(stateCode);
        if (cancelled) {
          return;
        }
        setRows(result.rows);
        setSummary(result.summary);
        if (result.rows.length === 0) {
          captureBeerIngestionReviewEmpty(stateCode);
        }
      } catch (loadError) {
        if (cancelled) {
          return;
        }
        captureBeerIngestionReviewError(null, null);
        setError(loadError?.message || 'Failed to load ingestion reviews');
        setRows([]);
        setSummary(EMPTY_SUMMARY);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };
    loadRows();
    return () => {
      cancelled = true;
    };
  }, [stateCode, reloadToken]);

  if (!stateCode) {
    return {
      rows: [],
      summary: EMPTY_SUMMARY,
      loading: false,
      error: null,
      refresh,
    };
  }

  return {
    rows,
    summary,
    loading,
    error,
    refresh,
  };
}
